import React from 'react';
import UpdateCustomer from './UpdateCustomer';

const CustomerDetails = () => {
    
    return (
        <div style={{marginBottom: 200}}>
            <h4>Customer Details</h4>
            <UpdateCustomer />
            {/* Buildings will be shown here */}
        </div>
    );
}
export default CustomerDetails;
